import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { upsertCountry } from "../../store/actions/adminAction";
import { useTranslation } from 'react-i18next';

function AddCountry({ setIsShow, onAdd, isEdit = false, defaultCountry = {} }) {
  const { t } = useTranslation();
  let dispatch = useDispatch();
  const [Country, setCountry] = useState(defaultCountry ?? {});

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(upsertCountry(Country, (a) => {
      setIsShow(false);
      onAdd(a);
    }))
  }

  const OnInput = (e) => { e.target.value = e.target.value.slice(0, e.target.dataset.maxlength) }
  return (
    <form className="px-6 pb-6 pt-3 bg-white max-h-[550px] overflow-auto" onSubmit={handleSubmit}>
      <div className="grid grid-cols-12 gap-3 w-full">
        <div className="col-span-4">
          <div className="text-midBlack text-[13px] font-normal mb-1">
            <label> {t('Code')}<span className="text-red-500 text-[14px]">*</span></label>
          </div>
          <input type="text" placeholder={t("Enter Code")}
            value={Country?.code} data-maxlength={4} onInput={OnInput}
            onChange={(e) => setCountry({ ...Country, code: e.target.value })}
            className="border border-gray-300 rounded-md py-1 text-[14px] w-[100%]" required />
        </div>
        <div className="col-span-4">
          <div className="text-midBlack text-[13px] font-normal mb-1">
            <label> {t('Name')}<span className="text-red-500 text-[14px]">*</span></label>
          </div>
          <input type="text" placeholder={t("Enter Name")}
            value={Country?.name}
            onChange={(e) => setCountry({ ...Country, name: e.target.value })}
            className="border border-gray-300 rounded-md py-1 text-[14px] w-[100%]" required />
        </div>
        <div className="col-span-4">
          <div className="text-midBlack text-[13px] font-normal mb-1">
            <label> {t('Full Name')}<span className="text-red-500 text-[14px]">*</span></label>
          </div>
          <input type="text" placeholder={t("Enter Full Name")}
            value={Country?.niceName}
            onChange={(e) => setCountry({ ...Country, niceName: e.target.value })}
            className="border border-gray-300 rounded-md py-1 text-[14px] w-[100%]" required />
        </div>
        <div className="col-span-4">
          <div className="text-midBlack text-[13px] font-normal mb-1">
            <label>{t("Phone Code")}<span className="text-red-500 text-[14px]">*</span></label>
          </div>
          <input type="number"
            placeholder={t("Enter Phone Code")}
            value={Country.phoneCode}
            data-maxlength={5}
            onInput={OnInput}
            onChange={(e) => setCountry({ ...Country, phoneCode: e.target.value })}
            className="border border-gray-300 rounded-md py-1 text-[14px] w-[100%]"
            required
          />
        </div>
        <div className="col-span-4">
          <div className="text-midBlack text-[13px] font-normal mb-1">
            <label> {t('Currency')}<span className="text-red-500 text-[14px]">*</span></label>
          </div>
          <input type="text" placeholder={t("Enter Currency")}
            value={Country?.currency}
            onChange={(e) => setCountry({ ...Country, currency: e.target.value })}
            className="border border-gray-300 rounded-md py-1 text-[14px] w-[100%]" required />
        </div>
        <div className="col-span-4">
          <div className="text-midBlack text-[13px] font-normal mb-1">
            <label> {t('Currency Code')}<span className="text-red-500 text-[14px]">*</span></label>
          </div>
          <input type="text" placeholder={t("Enter Currency Code")}
            value={Country?.currencyCode} data-maxlength={4} onInput={OnInput}
            onChange={(e) => setCountry({ ...Country, currencyCode: e.target.value })}
            className="border border-gray-300 rounded-md py-1 text-[14px] w-[100%]" required />
        </div>
      </div>
      <div className="flex justify-end gap-2 mt-4">
        <button type='button'
          className="px-[16px] py-[6px] text-[#644d81] font-medium text-[14px] bg-[#ECF0F7] transition-all ease-in-out rounded cursor-pointer hover:bg-[#e4e8ef]"
          onClick={() => setIsShow(false)}>
          {t("Cancel")}
        </button>
        <button type='submit'
          className="min-w-[76px] text-center px-[16px] py-[6px] text-white font-medium text-[14px] bg-theme transition-all ease-in-out rounded cursor-pointer hover:bg-primary">
          {t("Save")}
        </button>
      </div>
    </form>
  )
}

export default AddCountry